import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  MessageCircleIcon,
  Music2Icon,
  YoutubeIcon,
} from 'lucide-react'
import React from 'react'

/** Redes sociales disponibles en el footer de las landings. */
export const SOCIAL_NETWORKS: Record<
  string,
  { label: string; icon: React.ComponentType<{ className?: string }> }
> = {
  instagram: { label: 'Instagram', icon: InstagramIcon },
  youtube: { label: 'YouTube', icon: YoutubeIcon },
  linkedin: { label: 'LinkedIn', icon: LinkedinIcon },
  facebook: { label: 'Facebook', icon: FacebookIcon },
  tiktok: { label: 'TikTok', icon: Music2Icon },
  whatsapp: { label: 'WhatsApp', icon: MessageCircleIcon },
}

export const SOCIAL_NETWORK_OPTIONS = Object.entries(SOCIAL_NETWORKS).map(
  ([value, net]) => ({ value, label: net.label }),
)
